// extracted by mini-css-extract-plugin
export default {"li":"catalogues_li__2MVQ5","active":"catalogues_active__lPdPK"};